<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
}
</script>

<style lang="scss">
  
</style>



// WEBPACK FOOTER //
// App.vue?fbe072ca